import { gql } from '@apollo/client'

export const GENERATE_UPLOAD_URL_MUTATION = gql`
  mutation GENERATE_UPLOAD_URL_MUTATION($file: FileInput!) {
    generateUploadUrls(file: $file) {
      downloadUrl
      uploadUrl
      uploadFormData
    }
  }
`

export const GENERATE_UPLOAD_URL_PUBLIC_MUTATION = gql`
  mutation GENERATE_UPLOAD_URL_PUBLIC_MUTATION($file: FileInput!) {
    generateUploadUrlsPublic(file: $file) {
      downloadUrl
      uploadUrl
      uploadFormData
    }
  }
`
